import React, { type ReactNode } from 'react';
import { useAuth, usePermissions } from '../../context/AuthContext';
import type { RoleName } from '@hr-system/shared';

interface ProtectedRouteProps {
  children: ReactNode;
  requiredRoles?: RoleName[];
  requiredPermission?: keyof ReturnType<typeof usePermissions>;
  fallback?: ReactNode;
}

export function ProtectedRoute({
  children,
  requiredRoles,
  requiredPermission,
  fallback = <div>Access Denied</div>,
}: ProtectedRouteProps) {
  const { isAuthenticated, isLoading, user } = useAuth();
  const permissions = usePermissions();

  if (isLoading) {
    return <div className="loading-spinner">Loading...</div>;
  }

  if (!isAuthenticated || !user) {
    return <div>Please log in</div>;
  }

  if (requiredRoles && !requiredRoles.includes(user.role.name as RoleName)) {
    return <>{fallback}</>;
  }

  if (requiredPermission && !permissions[requiredPermission]) {
    return <>{fallback}</>;
  }

  return <>{children}</>;
}